/* eslint-disable max-len */
import {
    forwardRef,
    ForwardRefExoticComponent,
    ReactElement,
    Ref,
} from 'react';

import { SvgIconProps } from '../../../entities/Svg/Svg';

export const IconSearch: ForwardRefExoticComponent<SvgIconProps> = forwardRef(({
    className = '',
}, ref: Ref<SVGSVGElement>): ReactElement => (
    <svg ref={ref} viewBox="0 0 100 100" className={`icon ${className}`}>
        <circle className="icon__stroke" cx="42.2" cy="42.5" r="31.5" />
        <line className="icon__stroke" x1="64.6" y1="64.6" x2="90.1" y2="90.1" />
    </svg>
));
